import { Injectable } from '@angular/core';
import { IEletronicSignature } from '@services/strategy-pattern-login/iEletronic-Signature';
import { ConfigService } from '@services/webFeeder/config.service';
import { HttpService } from '@services/http-service';
import { Constants } from '@utils/constants';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IEletronicSignatureAdapterService implements IEletronicSignature {

  constructor(
    private _httpService: HttpService,
    private _configService: ConfigService,
  ) { }

  getSignatureParameters() {
    const theme = window.sessionStorage.getItem(Constants.LAYOUT_THEME_DARK) === 'true' ? 'dark' : 'light';
    const bodyStyles = window.getComputedStyle(document.body);
    const backgroundColor = bodyStyles.getPropertyValue(`--color-${theme}-background`);
    const textColor = bodyStyles.getPropertyValue(`--color-${theme}-text`);
    return this._httpService
      .doPost(this._configService.getEletronicSignatureURL(), 'AssinaturaEletronica/GerarTecladoLoginCustomizado', {
        BackgroundColor: backgroundColor,
        ButtonBackgroundColor: backgroundColor,
        TextColor: textColor,
        BorderColor: textColor,
        BorderRadius: 75
      }, false, false)
      .pipe(map(res => {
        if (res && res['StatusCode'] === 200 && res.IsResponseOk && res.SerializedObject) {
          return res;
        } else {
          throw new Error('Error getting parameters');
        }
      }));
  }

  validateSignature(signature) {
    const params = { HashTeclado: signature.hashTeclado, Pressionadas: signature.keys };
    return this._httpService
      .doPostWso2(this._configService.getEletronicSignatureURL(),
        'AssinaturaEletronica/AutenticarCodigoSeguranca', params, null, null, false, true)
      .pipe(map(res => {
        return res;
      }));
  }

  forgotPassword() {
    throw new Error('Method not implemented.');
  }

}
